import EntityCrudService from 'app/blocks/service/api/entity-service';
import {ITerritory, Territory} from 'app/blocks/model/territory.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {SERVER_API_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class TerritoryService extends EntityCrudService<ITerritory> {
    constructor(http: HttpClient) {
        super(http, Resource.TERRITORIES, (obj?) => new Territory(obj));
    }

    getTerritoryById = (territoryId: number): Promise<any> => {
        const REQUEST_URI = `${SERVER_API_URL}api/territories/${territoryId}`;
        return this.http.get(REQUEST_URI).toPromise();
    };

    postTerritory = (territoryId: number | null, territoryName: string, defaultRouteId?: number, postCodePrefixes?: any[]): Promise<any> => {
        const REQUEST_URI = `${SERVER_API_URL}api/territories`;
        const requestBody = {
            id: territoryId,
            name: territoryName,
            defaultRoute:
                defaultRouteId == null
                    ? null
                    : {
                          id: defaultRouteId
                      },
            postCodePrefixes: postCodePrefixes
        };
        return this.http.post<any>(REQUEST_URI, requestBody).toPromise();
    };
}
